module.exports = __webpack_public_path__ + "img/workbench_icon4.b42f8126.svg";